'use strict';
(function () {
  angular.module('pentaApp').factory('waitingList.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/waitingList', {}, {
      remove: {
        method: 'PUT',
        isArray: false
      }
    });
  }
})();
